var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentCenterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "20 9.8 24.5 9.8 29.5 14.9 29.5 32.2 11.7 32.2 11.7 9.8 16.1 9.8",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.5 9.8 24.5 15 29.5 14.9",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,14.1s0-4.9,0-6.4.7-2,2-2,2,.8,2,2v4.7c0,.4-.2,1-1,1s-1.1-.6-1.1-1v-3.3",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.9,
    y1: 20.1,
    x2: 26.3,
    y2: 20.1,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.9,
    y1: 26.1,
    x2: 26.2,
    y2: 26.1,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 20,
    rx: 1,
    ry: 1.1,
    style: {
      fill: "#0194d3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2,
    cy: 26.1,
    rx: 1,
    ry: 1.1,
    style: {
      fill: "#0194d3"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCenterIcon);
export default __webpack_public_path__ + "static/media/document-center-icon.a45c8f6038890efe3a6afb3b83d8a65f.svg";
export { ForwardRef as ReactComponent };